// src/utils/teachingPlan.js
// Editable Step 7 plan <-> markdown (mirrors app/services/plan_parser.py).

export const PLAN_COLUMNS = [
  { key: "session", label: "Week" },
  { key: "mlu", label: "MLU" },
  { key: "methods", label: "Teaching methods" },
  { key: "structure", label: "Example course structure" },
];

export const emptyRow = () => ({ session: "", mlu: "", methods: "", structure: "" });

const cell = (text) => String(text || "").replace(/\|/g, "\\|").replace(/\n/g, "<br>");

export function planToMarkdown(plan) {
  if (!plan) return "";
  const rows = plan.rows || [];
  if (rows.length === 0) return plan.markdown || plan.intro || "";
  const out = [];
  if (plan.intro) out.push(plan.intro.trim(), "");
  out.push(`| ${PLAN_COLUMNS.map((c) => c.label).join(" | ")} |`);
  out.push(`|${PLAN_COLUMNS.map(() => "---").join("|")}|`);
  rows.forEach((r) => out.push(`| ${PLAN_COLUMNS.map((c) => cell(r[c.key])).join(" | ")} |`));
  if (plan.outro) out.push("", plan.outro.trim());
  return out.join("\n");
}

/** "EDU-101: Title" -> "EDU-101" (first MLU code found in the cell). */
export function mluCodeOf(text) {
  const m = String(text || "").match(/\b(EDU|GOV|TEC|EID)-\d{3}\b/);
  return m ? m[0] : null;
}
